/**
 * Stub implementation of the legacy IAS video integration.
 *
 * IAS tags have been removed from the site, so this class is intentionally
 * left as a no-op to satisfy any legacy imports without initializing IAS.
 */
class IasVideo {
  // eslint-disable-next-line no-unused-vars
  constructor(field) {
    // IAS integration disabled – no event listeners or tag initialization.
  }
}

export default IasVideo;
